import * as compareVersions from 'compare-versions';
import { invokeSchemaByIframe, invokeSchemaByPrompt } from './core';
import { inApp, inAndroidApp } from './env';

// == app版本缓存
let appVersion: string | null = null;

/**
 * 获取app版本号，限8.4.2+，8.4.2以下不再支持.
 * @returns {Promise<string>|Promise<any>}
 */
export function getAppVersion() {
  if (appVersion) return Promise.resolve(appVersion);
  if (inApp) {
    return invokeSchemaByPrompt('qingtingfm://action.qingting.fm/device/info').then((res: any) => {
      if (res.app_version) appVersion = res.app_version;
      return res.app_version;
    });
  }
  appVersion = null;
  return Promise.resolve(null);
}

/**
 * 指定一个基准版本，与当前app版本做比较
 * @param baseVersion
 * @returns {Promise<{isGreaterOrEqual: boolean, isLess: boolean, isEqual: boolean, isGreater: boolean}>}
 * isGreaterOrEqual:当前版本大于等于基准版本
 * isLess:小于基准版本
 * isEqual:等于基准版本
 * isGreater:大于基准版本
 */
export function compareAppVersion(baseVersion: string): Promise<{
  isGreater?: boolean;
  isEqual?: boolean;
  isLess?: boolean;
  isGreaterOrEqual?: boolean;
  isLessOrEqual?: boolean;
  appVersion?: string | null;
}> {
  return getAppVersion().then((version) => {
    if (!version) return {};
    const isGreater = compareVersions.compare(version, baseVersion, '>');
    const isEqual = compareVersions.compare(version, baseVersion, '=');
    const isLess = !isGreater && !isEqual;
    const isGreaterOrEqual = isGreater || isEqual;
    const isLessOrEqual = isLess || isEqual;
    return { isGreater, isEqual, isLess, isGreaterOrEqual, isLessOrEqual, appVersion };
  });
}

/**
 * 根据版本号选择schema解析
 * @param schema 原生scheme地址
 * @param options 调用参数
 * @param originRes 是否原封不动接收返回值
 * @param unEncode 是否不加编码
 * @returns {Promise<any>}
 */
export function invokeSchema(schema: string, options?: Record<string, any>, originRes?: boolean, unEncode?: boolean) {
  if (inApp) {
    return compareAppVersion('8.4.2').then(({ isLess }) => {
      if (isLess) {
        return invokeSchemaByIframe(schema, options, originRes, unEncode);
      }
      return invokeSchemaByPrompt(schema, options, originRes, unEncode);
    });
  }
  // 站外直接调用schema
  // window.location.href = schema + '?' + stringifyQuery(options);
  return Promise.resolve();
}

/**
 * 检测页面是否处于激活状态，主要针对Android预加载
 */
export function checkPageActive(success: () => void): void {
  if (!inAndroidApp && success) {
    success();
    return;
  }
  let isActive = window.QTJsPlayer.isActive();
  if (isActive && success) {
    success();
    return;
  }
  const timer = setInterval(() => {
    isActive = window.QTJsPlayer.isActive();
    if (isActive) {
      clearInterval(timer);
      if (success) success();
    }
  }, 3000);
}
